<div class="container-fluid glb-popup">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  @if (isSearching) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <h2> {{title}}</h2>
  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>

    <div class="forms w-300 d-block">
      <div class="row m-0">
        <div class="col-lg-12">
          @if (!displayClose) {
            <br>
            }
            <p-table class="kbmadmintable res-ledger-list-table" [ngClass]="{'pop-up-table': isPopup}" #pt [value]="reservationLedgers" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="reservationLedgerId" selectionMode="single" [(selection)]="reservationLedger"
              [loading]="loading" [paginator]="showPagination" [rows]="100" [rowsPerPageOptions]="[100,150,200]" showCurrentPageReport="true"
              currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal" sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped"
              [ngStyle]="{'width': 'auto'}"  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

              <ng-template pTemplate="caption">
                <div class="d-block text-end orderdetails-btn">
                  <span>
                    <!--clear filters-->
                    <a href="https://admin.kbmhawaii.com/reservation-ledger/{{reservationId}}" target="_blank">
                      <i class="pi pi-external-link" title="Open in new tab"
                      aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"></i>
                    </a>
                    <button pButton pRipple class="p-button-text" style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;" (click)="refreshTable()">Clear Filters</button>
                    <app-import-export importEnabled="false" [dataRetrived]="reservationLedgers" (exportDataSelected)="exportAsExcelFile($event)" [columns]="excelColumns" [importDisabled]="true"></app-import-export>

                    <!--add new-->
                    <!--<button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;  margin-right:10px;" (click)="syncRuCreditVoucher()">Sync RU CreditVoucher</button>-->
                    <button pButton pRipple class="p-button-outlined" style=" margin-right:10px;" (click)="addTravelAgentPopUpDisplay()">Add Travel Agent</button>
                    <button pButton pRipple class="p-button-outlined"   style=" margin-right:10px;" (click)="addIntoOwnerStatementPopUpDisplay()">Add Into Owner Statement</button>
                    <button pButton pRipple class="p-button-danger"   style=" margin-right:10px;" (click)="onRegenerateTax(reservationId)">ReGenerate Tax</button>
                    <button pButton pRipple class="p-button-outlined" style=" margin-right:10px;" (click)="reGenerateNetIncome()">ReGenerate NetIncome</button>
                    <button pButton pRipple class="p-button-danger"   style=" margin-right:10px;" (click)="onDeleteByReservationId(reservationId)">Delete Ledger</button>

                    <button pButton pRipple class="p-button-outlined" style=" margin-right:10px;" (click)="generateLedgers()">Regenerate</button>
                    <button pButton pRipple class="p-button-outlined" style=" margin-right:10px;" (click)="lockLedger()">Lock</button>
                    <button pButton pRipple class="p-button-outlined" style=" margin-right:10px;" (click)="unlockLedger()">Unlock</button>
                    <button pButton pRipple class="p-button" (click)="onOpenFormAdd()">Add +</button>
                  </span>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr>
                  @for (col of columns; track col) {
                    <th [pSortableColumn]="col.sortingField" [ngStyle]="{'width': 'auto'}">
                      {{col.header}}
                      <p-sortIcon [field]="col.sortingField"></p-sortIcon>
                    </th>
                  }
                  <th [ngStyle]="{'width': 'auto'}">Total</th>
                  <th [ngStyle]="{'width': 'auto'}"></th>
                  <th [ngStyle]="{'width': 'auto'}"></th>
                </tr>
                @if (showFilter) {
                  <tr>
                    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.shortTermRentalVO.propertyCode', 'in')"></th>
                    <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.guestProfileVO.lastName', 'in')"></th> -->
                    <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th> -->
                    <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="date" (input)="pt.filter($event.target.value, 'reservationVO.checkInDateTime', 'in')"></th>
                    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="date" (input)="pt.filter($event.target.value, 'reservationVO.checkOutDateTime', 'in')"></th> -->
                    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'orderProductVO.name', 'in')"></th>
                    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'payFromOrderProductVO.name', 'in')"></th>
                    <th [ngStyle]="{'width': 'auto'}">
                      <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'payFrom', 'in')"> -->
                      <p-multiSelect [options]="reservationLedgerService.payToDetails" defaultLabel="name"
                      optionLabel="name" (onChange)="pt.filter($event.value, 'payFrom', 'in')" appendTo="body"></p-multiSelect>
                    </th>
                    <th [ngStyle]="{'width': 'auto'}">
                      <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'payTo', 'in')"> -->
                      <p-multiSelect [options]="reservationLedgerService.payToDetails" defaultLabel="name"
                      optionLabel="name" (onChange)="pt.filter($event.value, 'payTo', 'in')" appendTo="body"></p-multiSelect>
                    </th>
                    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'quantity', 'in')"></th>
                    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPrice', 'in')"></th>
                    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPriceAdjustmentPercent', 'in')">
                    </th>
                    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPriceAdjustmentAmount', 'in')">
                    </th>
                    <th [ngStyle]="{'width': 'auto'}"></th>
                    <th [ngStyle]="{'width': '20px'}"></th>
                    <th [ngStyle]="{'width': '20px'}"></th>
                  </tr>
                }
              </ng-template>
              <ng-template pTemplate="body" let-reservationLedger let-index="rowIndex">
                <tr [ngStyle]="{'font-style': reservationLedger?.ledgerItemType === 2 ? 'italic' : ''}" [pSelectableRow]="reservationLedger">
                  <td>
                    @if (reservationLedger?.ledgerItemType !== 2) {
                      <span>
                        {{reservationLedger.propertyCode}}
                      </span>
                    }
                  </td>
                  <td [class.ledger-item-indented]="reservationLedger?.ledgerItemType === 2" [style.padding-left.px]="reservationLedger?.ledgerItemType === 2 ? 40 : null">{{getReservationLedgerTitle(reservationLedger)}}</td>
                  <td>{{reservationLedger.payFromOrderProductName}}</td>
                  <td>{{getPayFromName(reservationLedger)}}</td>
                  <td>{{getPayToName(reservationLedger)}}</td>
                  <td>{{reservationLedger.quantity}}</td>
                  <td style="text-align: right;">{{reservationLedger.listPrice | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                  <td style="text-align: right;">{{reservationLedger.listPriceAdjustmentPercent | percent}}</td>
                  <td style="text-align: right;">{{reservationLedger.listPriceAdjustmentAmount | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                  <td style="text-align: right;">{{total(reservationLedger) | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                  <td><span style="float:none">
                    <a>
                      @if (reservationLedger?.ledgerItemType == 1  && reservationLedger?.regenerateOption == 1) {
                        <i class="pi pi-lock" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
                          (click)="toggleLedgerItemsLock(reservationLedger)"
                        ></i>
                      }
                    </a>
                    <a>
                      @if (reservationLedger?.ledgerItemType == 1 &&
                        (reservationLedger.regenerateOption == undefined || reservationLedger.regenerateOption == null || reservationLedger.regenerateOption == 0)) {
                        <i class="pi pi-lock-open"
                          (click)="toggleLedgerItemsLock(reservationLedger)"
                        aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"></i>
                      }
                    </a>

                    @if (reservationLedger?.ledgerItemType == 2  && reservationLedger?.regenerateOption == 1) {
                      <i class="pi pi-lock" aria-hidden="true" style="color:grey; font-size:110%; padding-right:20px;"
                      ></i>
                    }


                    @if (reservationLedger?.ledgerItemType == 2 &&
                      (reservationLedger.regenerateOption == undefined || reservationLedger.regenerateOption == null || reservationLedger.regenerateOption == 0)) {
                      <i class="pi pi-lock-open"
                      aria-hidden="true" style="color:grey; font-size:110%; padding-right:20px;"></i>
                    }

                  </span>
                </td>
                <td><span style="float:none">
                  <a>
                    <i class="pi pi-pencil" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(reservationLedger)"></i>
                  </a>
                </span>
              </td>
            </tr>
            @if ((reservationLedgers.length - 1) == index) {
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2">Total (Should equal $0.00)</td>
                <td style="text-align: right;">{{grandTotal() | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                <td></td>
              </tr>
            }
            @if ((reservationLedgers.length - 1) == index) {
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2">Net Income</td><!--Owner Income (orderProductId 105) + KBM Income (orderProductId 106) = Net Income-->
                <td style="text-align: right;">{{netIncome() | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                <td></td>
                <td></td>
              </tr>
            }
            @if ((reservationLedgers.length - 1) == index) {
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td colspan="2">Net Income + Tax</td><!--Owner Income (orderProductId 105) + KBM Income (orderProductId 106) = Net Income-->
                <td style="text-align: right;">{{netIncomeWithTax() | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                <td></td>
                <td></td>
              </tr>
            }

          </ng-template>


        </p-table>

      </div>
    </div>
  </div>
</div>

<p-dialog header="Add Into Owner Statement" [(visible)]="addIntoOwnerStatementPopUp"
  [style]="{'width': '90vw', 'max-width': '1400px'}" [contentStyle]="{'overflow': 'visible'}">
  <!-- ============== Bulk generate statement form==================== -->
  <div [formGroup]="form2" class="forms w-100 d-block create-reservation-form mt-3">
    <div class="row">

      <div class="col-6 mb-4">
        <span class="p-float-label w-100">
          <p-dropdown [options]="monthsForBulkGenerateStatement" formControlName="month" optionLabel="name"
          optionValue="value" placeholder="Month" styleClass="w-100"></p-dropdown>
          <label for="month">Month</label>
          @for (validation of validationMessages2.month; track validation) {
            <span>
              @if (form2.get('month').hasError(validation.type) && (form2.get('month').dirty || form2.get('month').touched)) {
                <small class="p-invalid">{{validation.message}}</small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-6 mb-4">
        <span class="p-float-label w-100">
          <p-dropdown [options]="yearsForBulkGenerateStatement" formControlName="year" optionLabel="name"
          optionValue="value" placeholder="Year" styleClass="w-100"></p-dropdown>
          <label for="year">Year</label>
          @for (validation of validationMessages2.year; track validation) {
            <span>
              @if (form2.get('year').hasError(validation.type) && (form2.get('year').dirty || form2.get('year').touched)) {
                <small class="p-invalid">{{validation.message}}</small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-6 mb-4">
        <span class="p-float-label w-100">
          <p-inputNumber formControlName="numNights" inputId="numNights" [min]="1" [useGrouping]="false"></p-inputNumber>
          <label for="numNights">Num Nights (optional)</label>
        </span>
        <small class="text-muted">Override nights — allows out-of-range reservations.</small>
      </div>

      <div class="col-6 mb-4">
        <span class="p-float-label w-100">
          <p-inputNumber formControlName="revenueAmt" inputId="revenueAmt" [minFractionDigits]="2"
            mode="currency" currency="USD" locale="en-US" [allowEmpty]="true"></p-inputNumber>
          <label for="revenueAmt">Revenue Amt (optional)</label>
        </span>
        <small class="text-muted">Positive = revenue adjustment &nbsp;|&nbsp; Negative = refund to guest.</small>
      </div>

      <div class="col-12 mb-4">
        <span class="p-float-label w-100">
          <p-dropdown [options]="revenueTypeOptions" formControlName="revenueType" optionLabel="name"
            optionValue="value" placeholder="Select Revenue Type (optional)" styleClass="w-100"></p-dropdown>
          <label for="revenueType">Revenue Type (optional)</label>
        </span>
        <small class="text-muted">
          Debit = charge / refund &nbsp;|&nbsp; Credit = revenue income &nbsp;|&nbsp;
          "without Tax" clears taxes &nbsp;|&nbsp; "without KBM Fee" gives owner full amount.
        </small>
      </div>

    </div>
  </div>

  <!-- Preview Panel - PDF Style -->
  @if (isPreviewLoading) {
    <div class="text-center my-3"><p-progressSpinner [style]="{'width':'40px','height':'40px'}"></p-progressSpinner></div>
  }
  @if (stmtPreview) {
    <div class="mt-3" style="font-size:0.80rem; overflow-x:auto;">
      <div style="font-weight:700; font-size:0.95rem; margin-bottom:6px; letter-spacing:0.03em;">RESERVATIONS</div>
      <table style="width:100%; border-collapse:collapse; border:1px solid #c8d0da;">
        <thead>
          <!-- Group header row -->
          <tr style="background:#dde3ea;">
            <th colspan="5" style="border:1px solid #c8d0da; padding:4px 8px;"></th>
            <th colspan="4" style="border:1px solid #c8d0da; padding:4px 8px; text-align:center; font-weight:600;">Revenue</th>
            <th colspan="2" style="border:1px solid #c8d0da; padding:4px 8px; text-align:center; font-weight:600;">Expense</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px;"></th>
            <th style="border:1px solid #c8d0da; padding:4px 8px;"></th>
          </tr>
          <!-- Column header row -->
          <tr style="background:#dde3ea; font-weight:600;">
            <th style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">Res #</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">Status</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">Name</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">From</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">To</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">Nights</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">Avg Daily Rent</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">Rents</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">Tax</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">Mgmt.</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">Tax</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">Net Rents</th>
            <th style="border:1px solid #c8d0da; padding:4px 8px;"></th>
          </tr>
        </thead>
        <tbody>
          <!-- Data row -->
          <tr style="background:#fff;">
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:center; color:#1565c0;">
              {{stmtPreview.reservationId}}
            </td>
            <td style="border:1px solid #c8d0da; padding:4px 8px;">{{getReservationStatusLabel(stmtPreview.reservationStatus)}}</td>
            <td style="border:1px solid #c8d0da; padding:4px 8px;">{{stmtPreview.guestName}}</td>
            <td style="border:1px solid #c8d0da; padding:4px 8px;">{{stmtPreview.checkInDate}}</td>
            <td style="border:1px solid #c8d0da; padding:4px 8px;">{{stmtPreview.checkOutDate}}</td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">{{stmtPreview.numNights}}</td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:right;">
              {{getNetRevenueDetail()?.amount | currency:'USD':'symbol':'1.2-2'}}
            </td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:right;">
              {{getNetRevenueDetail()?.subTotal | currency:'USD':'symbol':'1.2-2'}}
            </td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:right; white-space:nowrap;">
              {{getNetRevenueDetail()?.tax | currency:'USD':'symbol':'1.2-2'}}
              <i class="pi pi-info-circle ms-1" style="color:#1565c0; cursor:pointer;"
                [pTooltip]="getTaxTooltip(getNetRevenueDetail())" tooltipPosition="top" [escape]="false"></i>
            </td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:right;">
              {{getMgmtFeeDetail()?.subTotal | currency:'USD':'symbol':'1.2-2'}}
            </td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:right;">
              {{getMgmtFeeDetail()?.tax | currency:'USD':'symbol':'1.2-2'}}
            </td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:right; font-weight:600;">
              {{stmtPreview.rezTotal | currency:'USD':'symbol':'1.2-2'}}
            </td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">
              <i class="pi pi-info-circle" style="color:#1565c0; cursor:pointer;"
                [pTooltip]="'Res #' + stmtPreview.reservationId + ': ' + stmtPreview.guestName" tooltipPosition="top"></i>
            </td>
          </tr>
          <!-- Totals row -->
          <tr style="font-weight:700; border-top:2px solid #8b99a8; background:#eef1f5;">
            <td colspan="5" style="border:1px solid #c8d0da; padding:4px 8px;"></td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:center;">{{stmtPreview.numNights}}</td>
            <td style="border:1px solid #c8d0da; padding:4px 8px;"></td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:right;">
              {{getNetRevenueDetail()?.subTotal | currency:'USD':'symbol':'1.2-2'}}
            </td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:right;">
              {{getNetRevenueDetail()?.tax | currency:'USD':'symbol':'1.2-2'}}
            </td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:right;">
              {{getMgmtFeeDetail()?.subTotal | currency:'USD':'symbol':'1.2-2'}}
            </td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:right;">
              {{getMgmtFeeDetail()?.tax | currency:'USD':'symbol':'1.2-2'}}
            </td>
            <td style="border:1px solid #c8d0da; padding:4px 8px; text-align:right;">
              {{stmtPreview.rezTotal | currency:'USD':'symbol':'1.2-2'}}
            </td>
            <td style="border:1px solid #c8d0da; padding:4px 8px;"></td>
          </tr>
        </tbody>
      </table>
    </div>
  }

  <hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group w-100 justify-content-between">
        <div>
          <button pButton class="p-button-outlined p-button-secondary" (click)="previewBulkStatement()" [disabled]="isPreviewLoading">
            Preview
          </button>
        </div>
        <div>
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          <button pButton class="btn-addt p-button ms-2" (click)="generateBulkStatement()">Add</button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

  <p-dialog header="Add Travel Agent" [(visible)]="addTravelAgentPopUp"
    [style]="{width: 'auto',height:'550px'}">
    <!-- ============== Bulk generate statement form==================== -->
    <div [formGroup]="form1" class="forms w-100 d-block create-reservation-form mt-3">
      <div class="row">

        <div class="col-lg-12">

          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-autoComplete [(ngModel)]="selectedAgentProfile" [ngModelOptions]="{standalone: true}"
                [suggestions]="agentProfileSuggestions" (completeMethod)="searchAgentProfiles($event)"
                (onSelect)="onAgentSelect($event)" field="displayName" [minLength]="1" [forceSelection]="false"
                inputId="agentProfileSearch" styleClass="w-100" inputStyleClass="w-100" placeholder="">
              </p-autoComplete>
              <label for="agentProfileSearch">Search Agent Profile (optional)</label>
            </span>
          </div>

          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="agentName" id="agentName" type="text" pInputText>
              <label for="agentName">Agent Name</label>
              @for (validation of validationMessages.agentName; track validation) {
                <span>
                  @if (form1.get('agentName').hasError(validation.type) && (form1.get('agentName').dirty || form1.get('agentName').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-3">
              <p-inputNumber formControlName="agentAMT" [minFractionDigits]="2" inputId="currency-us"
                mode="currency" currency="USD" locale="en-US">
              </p-inputNumber>
              <label for="agentAMT">Agent Amount $</label>
              @for (validation of validationMessages.agentAMT; track validation) {
                <span>
                  @if (form1.get('agentAMT').hasError(validation.type) && (form1.get('agentAMT').dirty || form1.get('agentAMT').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-3">
              <p-dropdown class="w-100" [options]="percentages" formControlName="agentPCT" optionLabel="name"
              optionValue="value" placeholder="Agent PCT %"></p-dropdown>
              <label for="agentPCT">Agent PCT %</label>
              @for (validation of validationMessages.agentPCT; track validation) {
                <span>
                  @if (form1.get('agentPCT').hasError(validation.type) && (form1.get('agentPCT').dirty || form1.get('agentPCT').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

          <div class="col-lg-12">
            <span class="p-float-label w-100">
              <textarea formControlName="privateNotes" id="privateNotes" [rows]="2" pInputTextarea></textarea>
              <label for="privateNotes">Private Notes</label>
              @for (validation of validationMessages.privateNotes; track validation) {
                <span>
                  @if (form1.get('privateNotes').hasError(validation.type) && (form1.get('privateNotes').dirty || form1.get('privateNotes').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>

        </div>
        <div class="col-lg-12">
        </div>

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              <button pButton class="btn-addt p-button" (click)="addTravelAgent()">Add</button>
              <!-- <button *ngIf="readOnlySubmitBotton" pButton class="btn-addt p-button" (click)="generateBulkStatement()" readonly="true">Submit</button> -->
            </div>
          </div>
        </div>
      </div>
    </p-dialog>
